'use strict';

const { sizeColorPlp } = require('./sizeColorPlp');

var lozad = require("lozad");

function initSlickSliderFilter() {
  $(".js-plp-slider").slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "0",
    infinite: true,
    speed: 500,
  });
}

initSlickSliderFilter();

function lazyLoad() {
  // Lazy Loading
  var lazyLoadingObserver = lozad(".lozad", {
    rootMargin: "500px 0px",
    loaded: function (el) {
      $(el).addClass("lazy-loaded");
    },
  });
  lazyLoadingObserver.observe();
}

lazyLoad();

function initSlickPlp() {
  $(".js-plp-slider").not(".slick-initialized").slick({
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "0",
    infinite: true,
  });
  lazyLoad();
}

function stockFilterCategoryAfterClick(blockFilter) {

    var selectedSizesFiltre = [];
    var filtreTitle = blockFilter;

    filtreTitle.each(function () {

        selectedSizesFiltre = [];

        var checkedButtons = $(this).find(".skp-button-filtre.skp-checked");
        
            if (checkedButtons.length > 0) {
            checkedButtons.each(function() {
                var size = $(this).text().trim();
                selectedSizesFiltre.push(size);
            });

            var deleteButton = $(this).parent('.refinement').find('.remove-filtre-button');
            deleteButton.show();

            var stockFiltre = $(this).parent('.refinement').find('.filtre-stock-value');
            stockFiltre.text(selectedSizesFiltre.join(", "));
        }
    });    
}


function stockFilterCategory() {

    var selectedSizesFiltre = [];
    var filtreTitle = $('.accordion-content');

    filtreTitle.each(function () {

        selectedSizesFiltre = [];

        var checkedButtons = $(this).find(".skp-button-filtre.skp-checked");
        
            if (checkedButtons.length > 0) {
            checkedButtons.each(function() {
                var size = $(this).text().trim();
                selectedSizesFiltre.push(size);
            });

            var deleteButton = $(this).parent('.refinement').find('.remove-filtre-button');
            deleteButton.show();

            var stockFiltre = $(this).parent('.refinement').find('.filtre-stock-value');
            stockFiltre.text(selectedSizesFiltre.join(", "));
        }
    });    
}

stockFilterCategory();

function stockFilterColor() {
  var filtreTitle = $(".accordion-content");

  filtreTitle.each(function () {

    var checkedColors = $(this).find(".swatch-circle.selected");
    checkedColors.parents(".skp-color").addClass("color-selected");
    checkedColors.parents(".refinement").find(".filtre-stock-value").addClass("color-stock");
    checkedColors.parents(".refinement").addClass("color-category");

      if (checkedColors.length > 0) {
        var $refinementBlock = $(".color-category .values-space").clone();

        $refinementBlock.find(".skp-color").not(".color-selected").remove();

        $(".color-stock").append($refinementBlock);


        var deleteButton = checkedColors.parents(".refinement").find(".remove-filtre-button");
        deleteButton.show();
      }
  });
}

stockFilterColor();

function stockFilterPrice() {
    var selectedPriceFiltre = [];
    var filtreTitle = $('.accordion-content');

    filtreTitle.each(function () {
        selectedPriceFiltre = [];

        var checkedButtons = $(this).find(".skp-prix-filtre.skp-checked");
        
            if (checkedButtons.length > 0) {
            checkedButtons.each(function() {
                var price = $(this).siblings("span.stock-value").text().trim();
                selectedPriceFiltre.push(price);
            });

            var deleteButton = $(this).siblings('.remove-filtre-button');
            deleteButton.show();

            var stockFiltre = $(this).siblings('.filtre-stock-value');
            stockFiltre.text(selectedPriceFiltre.join(", "));

        }
    });  
}

stockFilterPrice();

function stockFilterTrier() {

    var filtreTitle = $('.trier-content');

        var checkedButtons = filtreTitle.find(".trier-checked");
        
        if (checkedButtons.length > 0) {
                checkedButtons.each(function() {
                var trier = $(this).find("span").text().trim();
                var stockFiltre = filtreTitle.siblings('.filtre-stock-value');
                stockFiltre.text(trier);
           });
        }
}

stockFilterTrier();

// Variable globale pour sauvegarder l'état des filtres
var filterState = {};

// Fonction pour sauvegarder l'état des filtres
function saveFilterState() {
    $('.card-header').each(function() {
        var tabId = $(this).attr('data-tab');
        filterState[tabId] = $(this).hasClass('filtre-arrow');
    });
}

// Fonction pour restaurer l'état des filtres
function restoreFilterState() {
    $.each(filterState, function(tabId, isOpen) {
        var $accordionTitle = $('.card-header[data-tab="' + tabId + '"]');
        if (isOpen) {
            $accordionTitle.addClass('filtre-arrow');
            $('#' + tabId).show();
        } else {
            $accordionTitle.removeClass('filtre-arrow');
            $('#' + tabId).hide();
        }
    });
}

function adjustHeaderFiltreHeight() {
    $('.refinement').each(function() {
        var refinementParent = $(this);
        var cardHeader = refinementParent.find('.card-header');

        if (!cardHeader.hasClass('filtre-arrow')) {
            var refinementParent = $(this);
            var parentHeight = refinementParent.outerHeight();
            refinementParent.find('.header-filtre').height(parentHeight);
        }
    });
}

adjustHeaderFiltreHeight();

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('input.' + option.id).val(option.url);
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar').addClass('show-refinement-bar');
            $('.SKP-show-result').addClass('show-refinement-result');
            $('.modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('body').addClass('menu-open-mobile');
            $('.refinement-bar .close').focus();
            function hauteurFilter(){
                var heightHeaderFilter = $('.filter-header').height();
                var HeightWindow = $(window).height() - 1;
                $('.refinement-body').css({ 'min-height' : HeightWindow - heightHeaderFilter +'px'})
                }
                hauteurFilter();
                $(window).on('resize', function(){
                    hauteurFilter()
                });
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar .show-result-filtre, .modal-background', function () {
            $('.refinement-bar').removeClass('show-refinement-bar');
            $('.SKP-show-result').removeClass('show-refinement-result');
            $('.modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('body').removeClass('menu-open-mobile');
        });
    },

    resize: function () {
        var isScrolling;

        function closeOnResize() {
            $('.refinement-bar').removeClass('show-refinement-bar');
            $('.SKP-show-result').removeClass('show-refinement-result');
            $('.modal-background').hide();
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        }

        $(window).resize(function () {
            clearTimeout(isScrolling);

            isScrolling = setTimeout(function () {
                if (!isScrolling) {
                    closeOnResize();
                }
            }, 200);
        });

        $(window).on('scroll', function () {
            clearTimeout(isScrolling);
            isScrolling = true;
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order] input', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    initSlickPlp();
                    sizeColorPlp();
                    $('.newGrid').children('.skp-product-tile').removeClass('col-6 col-md-4 p-0 oldTileGrid').addClass('newTileGrid');
                    $('.newGrid').addClass('push-media-removed');
                    $('.trier-header .header-filtre').click(function(e) {
                        if ($(this).parents('.trier-header').hasClass('filtre-arrow')) {
                            $(this).parents('.refinement').find('.filtre-stock-value').empty();
                        } else {
                            setTimeout(function () {
                                stockFilterTrier();
                            }, 300);
                        }
                    });
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        var isLoading = false;
        $('.container').on('click', '.show-more button', function (e) {
            isLoading = true;
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            var pageNumber = $('#next-page-href').data('page-number');
            var blockLoader = $('.plp-loader-block');
            e.preventDefault();
            blockLoader.height(130);
            blockLoader.spinner().start();
            $(this).trigger('search:showMore', e);
            $.ajax({
                url: showMoreUrl,
                data: {
                    selectedUrl: showMoreUrl,
                    pageNumber: pageNumber
                },
                method: 'GET',
                success: function (response) {
                    isLoading = false;
                    $('.grid-footer').replaceWith(response);
                    initSlickPlp();
                    sizeColorPlp();
                    $('.newGrid').children('.skp-product-tile').removeClass('col-6 col-md-4 p-0 oldTileGrid').addClass('newTileGrid');
                    if($('.newGrid').hasClass('push-media-removed')){
                        $('.push-media').remove();
                    }
                    var pushMedia = $('.push-media-block');

                    pushMedia.each(function () {
                        var btnPushMedia = $(this).find('.push-media-footer .btn')
                        if($(this).find('.push-media-content').hasClass('push-media-title-bottom')){
                            $(this).find('.push-media-title').insertBefore(btnPushMedia);
                        }
                    });
                    updateSortOptions(response);
                    blockLoader.spinner().stop();
                    blockLoader.height(0);
                    var skpCountProduct = $('.skp-product-tile').length;
                    $(".skp-number-product .skp-load-more-p").text(function (i, txt) {
                        return txt.replace(/\d+/, skpCountProduct);
                    });
                },
                error: function () {
                    blockLoader.spinner().stop();
                    blockLoader.height(0);
                }
            });
        });
        
        if ($('.skp-seoBanner').length) {
            var footer  = document.getElementById("skp-seoBanner-content");
        } else {
            var footer  = document.getElementById("footercontent");
        }

        document.addEventListener("scroll", function (e) {
            let isScrollToBottom = (this.oldScroll || 0) < window.pageYOffset

            if (isVisible(footer) && isScrollToBottom && !isLoading) {
                $('.show-more button').click();
                initSlickPlp();
                sizeColorPlp();
                $('.newGrid').children('.skp-product-tile').removeClass('col-6 col-md-4 p-0 oldTileGrid').addClass('newTileGrid');
            }
            this.oldScroll = window.pageYOffset;
        });
        var heightOfProduct = $('.skp-product-tile').outerHeight();
        var doubleHeightOfProduct = heightOfProduct * 2;

        function isVisible(elm) {
            var rect = elm.getBoundingClientRect();
            if ($('.newGrid').length) {
                var adjustment = parseInt(doubleHeightOfProduct, 10);
            } else {
                var adjustment = parseInt(heightOfProduct, 10);
            }
            var adjustedTop = rect.top - adjustment;
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || adjustedTop - viewHeight >= 0);
        }
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements ul button, .refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                saveFilterState();
                $.spinner().start();
                $(this).trigger('search:filter', e);

                var isResetFilter = $(this).hasClass('skp-reset');

                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);

                        applyPriceFilter(); 

                        if (isResetFilter) {
                            resetFilter();
                        }

                        var $refinements = $(".refinements");
                        if ($refinements.is(':empty')) {
                            $('.no-result-filter').removeClass('d-none');
                            $('.no-result-filter .result-skp-product').removeClass('d-none');
                            $('.result-filter').addClass('d-none');
                        } else {
                            $('.no-result-filter').addClass('d-none');
                            $('.no-result-filter .result-skp-product').addClass('d-none');
                            $('.result-filter').removeClass('d-none');
                        }
                        initSlickPlp();
                        sizeColorPlp();
                        
                        $('.newGrid').children('.skp-product-tile').removeClass('col-6 col-md-4 p-0 oldTileGrid').addClass('newTileGrid');
                        $('.newGrid').addClass('push-media-removed');
                        
                        $('.accordion-title-filtre .header-filtre').click(function(e) {
                            var accordionitem = $(this).parents('.accordion-title-filtre').attr('data-tab');
                            $("#"+accordionitem).slideToggle();
                        
                            $(this).parents('.accordion-title-filtre').toggleClass('filtre-arrow');
                            $("#"+accordionitem).removeClass('filtre-arrow');

                            if($(this).parents('.accordion-title-filtre').hasClass('filtre-arrow')){
                                $(this).parent('.refinement').removeClass('stock-filtre-full');
                            } else if($(this).parent('.refinement').find('.filtre-stock-value').text().trim() !== '') {
                                $(this).parent('.refinement').addClass('stock-filtre-full');
                            }
                        });

                        var parentRefinementPrice = $('.price-values').parents('.refinement');
                        var stockValuePrice = parentRefinementPrice.find('.filtre-stock-value');

                        $('.swatch-circle').parents('.refinement').find('.accordion-title-filtre').addClass('color-title');
                        $('.skp-button-filtre').parents('.refinement').find('.accordion-title-filtre').addClass('category-title');
                        parentRefinementPrice.find('.accordion-title-filtre').addClass('price-title');
                        $('.stock-value-price').insertAfter(stockValuePrice);
                        
                        $('.accordion-title-filtre.color-title .header-filtre').click(function(e) {
                            if ($('.swatch-circle').parents('.refinement').find('.accordion-title-filtre').hasClass('filtre-arrow')) {
                                $('.color-stock').empty();
                            } else {
                                setTimeout(function () {
                                    stockFilterColor();
                                    adjustHeaderFiltreHeight();
                                }, 300);
                            }
                       });

                       $('.accordion-title-filtre.category-title .header-filtre').click(function(e) {
                        var  accordionContent = $(this).parents('.refinement').find('.accordion-content');
                            if ($(this).parents('.accordion-title-filtre').hasClass('filtre-arrow')) {
                                $(this).parents('.refinement').find('.filtre-stock-value').empty();
                            } else {
                                setTimeout(function () {
                                    stockFilterCategoryAfterClick(accordionContent);
                                    saveFilterState();
                                    adjustHeaderFiltreHeight();
                                }, 300);
                            }
                       });

                        $('.accordion-title-filtre.price-title .header-filtre').click(function(e) {
                            if ($(this).parents('.accordion-title-filtre').hasClass('filtre-arrow')) {
                                $(this).parents('.refinement').find('.filtre-stock-value').empty();
                                $('.stock-value-price').removeClass('d-block').addClass('d-none');;
                            } else {
                                setTimeout(function () {
                                    stockFilterPrice();
                                    adjustHeaderFiltreHeight();
                                    if( $('.skp-price').hasClass('show-price')) {
                                        $('.stock-value-price').removeClass('d-none').addClass('d-block');
                                    }
                                }, 300);
                            }
                        });

                        stockFilterColor();
                        stockFilterCategory();
                        stockFilterPrice();
                        applyTrier();
                        adjustHeaderFiltreHeight();

                        var filtreTitle = $('.accordion-content');

                        filtreTitle.each(function () {
                      
                            var refinement = $(this).parent('.refinement');
                            var stockFiltre = refinement.find('.filtre-stock-value');
                      
                            if (refinement.find('.accordion-title-filtre').hasClass('filtre-arrow')) {
                                stockFiltre.empty();
                            }
                        }); 

                        restoreFilterState();

                        $.spinner().stop();

                        $('.refinement .values').each(function () {

                            if ($(this).find('.skp-filtres').hasClass('skp-size')) {
                                $(this).addClass('values-space');
                            } else if ($(this).find('.skp-filtres').hasClass('skp-color')) {
                                $(this).addClass('values-space');
                            } else if ($(this).find('.skp-filtres').hasClass('skp-attr')) {
                                $(this).addClass('values-space');
                            };
                            $('.detailed-size').parent('.values').addClass('detailed-size-block');
                            $('.detailed-size').parents('.refinement').addClass('detailed-size-refinement');
                        });

                        $('.filtre-stock-value').each(function() {
                            if ($(this).text().trim() !== '' && !$(this).parent('.category-title').hasClass('filtre-arrow')) {
                                $(this).parents('.refinement').addClass('stock-filtre-full');
                            }
                        });

                        var filtreTitle = $('.accordion-content');

                        filtreTitle.each(function () {

                            var refinement = $(this).parent('.refinement');
                            var stockFiltre = refinement.find('.filtre-stock-value');

                            if (refinement.find('.accordion-title-filtre').hasClass('filtre-arrow')) {
                                stockFiltre.empty();
                            }
                        });    
                        
                        // Rappeler la fonction applyPriceFilter après l'appel AJAX
                        var stockValue = $('.stock-value-price');
                        if (stockValue.text().trim() !== "" && !stockValue.parents('.refinement').find('.accordion-title-filtre').hasClass('filtre-arrow')) {
                            $('.stock-value-price').removeClass('d-none').addClass('d-block');
                        }

                        if ($('.swatch-circle').parents('.refinement').find('.accordion-title-filtre').hasClass('filtre-arrow')) {
                            $('.color-stock').empty();
                        } else {
                            stockFilterColor();
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    }
};
$('.refinement .values').each(function () {

    if ($(this).find('.skp-filtres').hasClass('skp-size')) {
        $(this).addClass('values-space');
    } else if ($(this).find('.skp-filtres').hasClass('skp-color')) {
        $(this).addClass('values-space');
    } else if ($(this).find('.skp-filtres').hasClass('skp-attr')) {
        $(this).addClass('values-space');
    };
    $('.detailed-size').parent('.values').addClass('detailed-size-block');
    $('.detailed-size').parents('.refinement').addClass('detailed-size-refinement');
});

$('.show-result-filtre').on('click', function () {
    $('.skp-count-mobile .search-result-count').empty().html($('.result-count .search-result-count').html());
});

function PLPHeightImage() {
    var window_Width = $(window).width(),
        PLP_width = (1/3 * window_Width),
        PLP_width_New = (1/2 * window_Width);

    if (window_Width > 840) {
        var PLP_Height = (PLP_width * 1.24);
        $('.skp-product-tile .product-tile .image-container, .product-tile .skp-fullscreen-vimeo,.skp-product-tile .product-tile .slide-box,.skp-product-tile .product-tile .slick-list').css('height', PLP_Height);

        var PLP_Height_New_Grid_Desktop = (PLP_width_New * 1.24);
        $('.newGrid > :nth-child(22n + 7) .image-container, .newGrid > :nth-child(22n + 8) .image-container, .newGrid > :nth-child(22n + 21) .image-container, .newGrid > :nth-child(22n + 22) .image-container,.newGrid > :nth-child(22n + 7) .slick-list, .newGrid > :nth-child(22n + 8) .slick-list, .newGrid > :nth-child(22n + 21) .slick-list, .newGrid > :nth-child(22n + 22) .slick-list,.newGrid > :nth-child(22n + 7) .slide-box, .newGrid > :nth-child(22n + 8) .slide-box, .newGrid > :nth-child(22n + 21) .slide-box, .newGrid > :nth-child(22n + 22) .slide-box,.newGrid > :nth-child(22n + 7).push-media,.newGrid > :nth-child(22n + 8).push-media,.newGrid > :nth-child(22n + 21).push-media,.newGrid > :nth-child(22n + 22).push-media').each(function() {
            $(this).css({
                'min-height': PLP_Height_New_Grid_Desktop + 'px'
            });
        });
    } else {
        var PLP_width = (1/2 * window_Width),
            PLP_Height = (PLP_width * 1.24);
        $('.skp-product-tile .product-tile .image-container, .product-tile .skp-fullscreen-vimeo,.skp-product-tile .product-tile .slide-box,.skp-product-tile .product-tile .slick-list').css('height', PLP_Height);
        var PLP_Height_New_Grid_Mobile = (window_Width * 1.24);

        $('.newGrid > :nth-child(22n + 7) .image-container, .newGrid > :nth-child(22n + 8) .image-container, .newGrid > :nth-child(22n + 21) .image-container, .newGrid > :nth-child(22n + 22) .image-container,.newGrid > :nth-child(22n + 7) .slick-list, .newGrid > :nth-child(22n + 8) .slick-list, .newGrid > :nth-child(22n + 21) .slick-list, .newGrid > :nth-child(22n + 22) .slick-list,.newGrid > :nth-child(22n + 7) .slide-box, .newGrid > :nth-child(22n + 8) .slide-box, .newGrid > :nth-child(22n + 21) .slide-box, .newGrid > :nth-child(22n + 22) .slide-box,.newGrid > :nth-child(22n + 7).push-media,.newGrid > :nth-child(22n + 8).push-media,.newGrid > :nth-child(22n + 21).push-media,.newGrid > :nth-child(22n + 22).push-media').each(function() {
            $(this).css({
                'min-height': PLP_Height_New_Grid_Mobile + 'px'
            });
        });

    }
}

$(document).ready(function () {
    PLPHeightImage();
});

$(window).on('load resize scroll', function () {
    PLPHeightImage();
});



function breadcrumbPLP() {
        var bread_Width = $('.search-breadcrumb').width(),
            breadcrumb_UlWidth = $('.skp-breadcrumb').width(),
            window_Width = $(window).width();
    
        if (window_Width < 1368 && bread_Width < breadcrumb_UlWidth) {
    
            $('.breadcrumb-item:eq(0)').addClass('d-none');
            $('.breadcrumb-item:eq(1)').addClass('breadcrumb-none')
            $('.breadcrumb-item:eq(1) span').text('...');
        }
    }
    
    breadcrumbPLP();
    
    $(window).on('resize', function () {
        breadcrumbPLP();
});

require("./sizeColorPlp");
sizeColorPlp();

var widthRefinementBar = $('.refinement-bar').outerWidth();
$('.refinement-bar').css('right' ,-widthRefinementBar);

var currentGroupIndex = 0;
var groupWidths = [];
var totalFastAccessLabelWidth = 0;
var fastAccessWidth = $('.fast-access').width();

function calculateAccessWidths() {
    var slickSlides = $('.fast-access .slick-slide');
    totalFastAccessLabelWidth = 0;
    groupWidths = [];

    // Calculer la largeur totale de tous les éléments
    slickSlides.each(function() {
        totalFastAccessLabelWidth += $(this).outerWidth(true); 
    });

    // Boucler par groupe de trois éléments
    for (var i = 0; i < slickSlides.length; i += 3) {
        var groupWidth = 0;
        var groupCount = Math.floor(i / 3) + 1;

        // Calculer la largeur du groupe de trois éléments
        for (var j = i; j < i + 3 && j < slickSlides.length; j++) {
            groupWidth += $(slickSlides[j]).outerWidth(true);
        }

        // Stocker la largeur du groupe dans le tableau
        groupWidths.push({ group: groupCount, width: groupWidth });
    }
}

function updateArrows(slick, currentSlide) {

    if (currentSlide === 0) {
        $('.fast-access .slick-prev').addClass('slick-disabled').attr('aria-disabled', 'true');
    } else {
        $('.fast-access .slick-prev').removeClass('slick-disabled').attr('aria-disabled', 'false');
    }

    if (totalFastAccessLabelWidth < fastAccessWidth) {
        $('.fast-access .slick-next').addClass('slick-disabled').attr('aria-disabled', 'true');
    } else {
        $('.fast-access .slick-next').removeClass('slick-disabled').attr('aria-disabled', 'false');
    }
}

var $carousel = $('.fast-access');

$carousel.on('init', function(event, slick){
    calculateAccessWidths();
    updateArrows(slick, slick.currentSlide);
});

$carousel.on('afterChange', function(event, slick, currentSlide){
    updateArrows(slick, currentSlide);
});

$carousel.slick({
    infinite: false,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 3,
    arrows: true,
    responsive: [
        {
            breakpoint: 840, 
            settings: {
                swipe: true
            }
        },
        {
            breakpoint: 9999,
            settings: {
                swipe: false
            }
        }
    ]
});

$('.fast-access .slick-next').on('click', function() {
    if (currentGroupIndex < groupWidths.length) {
        totalFastAccessLabelWidth -= groupWidths[currentGroupIndex].width;
        currentGroupIndex++;

        if (totalFastAccessLabelWidth < fastAccessWidth) {
            $(this).addClass('slick-disabled').attr('aria-disabled', 'true');
        }
    }
});

$('.fast-access .slick-prev').on('click', function() {
    if (currentGroupIndex > 0) {
        currentGroupIndex--;
        totalFastAccessLabelWidth += groupWidths[currentGroupIndex].width;
        if (totalFastAccessLabelWidth >= fastAccessWidth) {
            $('.fast-access .slick-next').removeClass('slick-disabled').attr('aria-disabled', 'false');
        }
    }
});


$(document).ready(function() {
    var windowWidth = $(window).width();

    var topBannerImage;
    if (windowWidth > 840) {
        topBannerImage = $('.top-banner-image.top-banner-Desktop');
    } else {
        topBannerImage = $('.top-banner-image.top-banner-Mobile');
    }

    if (topBannerImage.length) {
        var backgroundImage = topBannerImage.css('background-image');

        if (backgroundImage && backgroundImage !== 'none') {
            var match = backgroundImage.match(/url\("?(.+?)"?\)/);
            var url = match ? match[1] : '';

            if (url) {
                var img = new Image();
                img.src = url;

                topBannerImage.css('min-height', '143px');

                img.onload = function() {
                    var imgWidth = img.naturalWidth;
                    var imgHeight = img.naturalHeight;

                    var aspectRatio = imgHeight / imgWidth;
                    var minHeight = 143;

                    function adjustHeight() {
                        var windowWidth = $(window).width();
                        var newHeight = windowWidth * aspectRatio;

                        if (newHeight < minHeight) {
                            topBannerImage.css('min-height', '');
                        } else {
                            topBannerImage.css({'min-height': newHeight + 'px', 'background-size': 'cover','background-position' : 'center'});
                        }
                    }

                    adjustHeight();

                    $(window).resize(function() {
                        adjustHeight();
                    });
                };
            }
        }
    }
});

var btn = $('.back-to-top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
});

btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
});


var pushMedia = $('.push-media-block');

pushMedia.each(function () {
    var btnPushMedia = $(this).find('.push-media-footer .btn')
    if($(this).find('.push-media-content').hasClass('push-media-title-bottom')){
        $(this).find('.push-media-title').insertBefore(btnPushMedia);
    }
});

$('.accordion-title-filtre .header-filtre').click(function(e) {
    if (!$(e.target).closest('.remove-filtre-selected').length) {
        var accordionitem = $(this).parents('.accordion-title-filtre').attr('data-tab');
        $("#" + accordionitem).slideToggle();
        $(this).parents('.accordion-title-filtre').toggleClass('filtre-arrow');
        $("#" + accordionitem).removeClass('filtre-arrow');
    }
    var $refinement = $(this).parents('.accordion-title-filtre').parent('.refinement');

    if($(this).parents('.accordion-title-filtre').hasClass('filtre-arrow')){
        $refinement.removeClass('stock-filtre-full');
        $refinement.find('.filtre-stock-value').addClass('d-none');
    } else if($refinement.find('.filtre-stock-value').text().trim() !== '') {
        $refinement.addClass('stock-filtre-full');
        $refinement.find('.filtre-stock-value').removeClass('d-none');
    }
});

function applyTrier() {
    $('.trier-header .header-filtre').click(function(e) {
            var accordionitem = $(this).parents('.trier-header').attr('data-tab');
            $("#" + accordionitem).slideToggle();
            $(this).parents('.trier-header').toggleClass('filtre-arrow');
            $("#" + accordionitem).removeClass('filtre-arrow');
            adjustHeaderFiltreHeight();
    });

    $('.skp-filtres.custom-radio').click(function(){
        $(this).find('input[type=radio]').prop('checked', true).trigger('change');
    });

    $("input[type=radio][name=sort-order]").change(function(){
        $("input[type=radio][name=sort-order]").each(function(){
            $(this).closest(".custom-radio").find("label").removeClass("trier-checked");
        });
        
        if ($(this).is(":checked")) {
            $(this).closest(".custom-radio").find("label").addClass("trier-checked");
        }
    });
}

applyTrier();

$('.accordion-title-filtre.price-title .header-filtre').click(function(e) {
    if ($(this).parents('.accordion-title-filtre').hasClass('filtre-arrow')) {
        $('.stock-value-price').removeClass('d-block').addClass('d-none');
    } else {
        if( $('.skp-price').hasClass('show-price')) {
            $('.stock-value-price').removeClass('d-none').addClass('d-block');
        }
    }
});

var $valueFrom = $('#valueFrom');
var $valueTo = $('#valueTo');

var valueFrom = parseInt($valueFrom.text());
var valueTo = parseInt($valueTo.text());

$('.skp-reset').data('value-price-min' , valueFrom);
$('.skp-reset').data('value-price-max' , valueTo);

$('.skp-reset').attr('data-value-price-min' , valueFrom);
$('.skp-reset').attr('data-value-price-max' , valueTo);

var resetMinValue = $('.skp-reset').data('value-price-min');
var resetMaxValue = $('.skp-reset').data('value-price-max');

// Variables globales pour conserver les valeurs
var currentValueFrom = valueFrom;
var currentValueTo = valueTo;

var isResetButtonVisible = false;
var currentStockValueText = ''; // Variable globale pour stocker la valeur de stockValue
var initialValueFrom = $('#valueFrom'); // Valeur initiale pour le minimum
var initialValueTo = $('#valueTo'); // Valeur initiale pour le maximum
var isResetAction = false;

// Fonction pour appliquer le filtre
function applyPriceFilter() {
    var $valueFrom = $('#valueFrom');
    var $valueTo = $('#valueTo');

    var minvalueFrom = parseInt($valueFrom.text());
    var maxvalueTo = parseInt($valueTo.text());

    initialValueFrom = minvalueFrom; // Sauvegarder les valeurs initiales
    initialValueTo = maxvalueTo;

    // Utilisation des valeurs globales au lieu de lire les éléments DOM à chaque fois
    var valueFrom = currentValueFrom;
    var valueTo = currentValueTo;

    var resetButton = $('.skp-price').parents('.refinement').find('.remove-filtre-button');
    var stockValue = $('.stock-value-price');

    var labelMinPrice = stockValue.data('value-min');
    var labelMaxPrice = stockValue.data('value-max');
    var currencySymbol = stockValue.data('currency-symbol');

    // Restaurer l'état du bouton reset
    if (isResetButtonVisible) {
        resetButton.css('display', 'block');
        $('.skp-price').addClass('show-price');
    }
    // Restaurer l'état de stockValue si disponible
    if (currentStockValueText) {
        stockValue.text(currentStockValueText);
    }

    // Initialisation ou mise à jour du slider
    $("#slider-range").slider({
        range: true,
        min: minvalueFrom,
        max: maxvalueTo,
        values: [valueFrom, valueTo],
        slide: function (event, ui) {
            // Vérifier que la différence est toujours d'au moins 1
            if (ui.values[1] - ui.values[0] < 1) {
                // Bloquer le mouvement selon la poignée utilisée
                if (ui.handleIndex === 0) {
                    // Si la poignée gauche (min) est déplacée trop près de max
                    return false;
                } else if (ui.handleIndex === 1) {
                    // Si la poignée droite (max) est déplacée trop près de min
                    return false;
                }
            }
            // Ici, on met à jour uniquement le slider, pas l'affichage
            $valueFrom.text(ui.values[0]);
            $valueTo.text(ui.values[1]);
        },
        change: function (event, ui) {

                resetButton.css('display', 'block');
                $('.skp-price').removeClass('show-price');
                isResetButtonVisible = true;

                currentValueFrom = ui.values[0];
                currentValueTo = ui.values[1];

                var newStockValue = `${labelMinPrice} ${currentValueFrom}${currencySymbol} ${labelMaxPrice} ${currentValueTo}${currencySymbol}`;
                stockValue.text(newStockValue);
                currentStockValueText = newStockValue;

                if (currentValueFrom === initialValueFrom && currentValueTo === initialValueTo) {
                    resetButton.css('display', 'none');
                    $('.skp-price').removeClass('show-price');
                    isResetButtonVisible = false;
                } else {
                    resetButton.css('display', 'block');
                    $('.skp-price').addClass('show-price');
                    isResetButtonVisible = true;
                }
                if (!isResetAction) { // Exécuter seulement si ce n'est pas une action de réinitialisation
                    var $button = $('.skp-price button');
                    var url = $button.data('href');
                    var updatedUrl = updateUrlParams(url, {
                        pmin: currentValueFrom,
                        pmax: (currentValueTo + 1)
                    });

            
                    $button.data('href', updatedUrl);
                    $button.attr('data-href', updatedUrl);
                    $button.trigger('click'); // Mise à jour et action
                }
        }
    });

    // Mettre à jour les valeurs affichées au chargement sans toucher à l'affichage
    // Cette partie ne touche pas les valeurs textuelles, qui sont uniquement liées au slider.
    $valueFrom.text($("#slider-range").slider("values", 0));
    $valueTo.text($("#slider-range").slider("values", 1));

    // Ajouter un événement pour le bouton reset
    resetButton.off('click').on('click', resetFilter);

}

    // Fonction pour réinitialiser le filtre
    function resetFilter() {

        var $valueFromMin = $('#valueFrom');
        var $valueToMax = $('#valueTo');

        // Réinitialiser les valeurs du slider
        isResetAction = true;
        var resetButton = $('.skp-price').parents('.refinement').find('.remove-filtre-button');
        var stockValue = $('.stock-value-price');

        var labelMinPrice = stockValue.data('value-min');
        var labelMaxPrice = stockValue.data('value-max');
        var currencySymbol = stockValue.data('currency-symbol');
        $("#slider-range").slider('values', [resetMinValue, resetMaxValue]);


        // Réinitialiser les textes affichés
        $valueFromMin.text(resetMinValue);
        $valueToMax.text(resetMaxValue);

        // Réinitialiser le texte de stockValue
        var resetStockValue = `${labelMinPrice} ${currentValueFrom}${currencySymbol} ${labelMaxPrice} ${currentValueTo}${currencySymbol}`;
        stockValue.text(resetStockValue);
        currentStockValueText = resetStockValue;

        // Cacher le bouton reset
        resetButton.css('display', 'none');
        isResetButtonVisible = false;
        setTimeout(() => { isResetAction = false; }, 0); 
    }

// Fonction pour mettre à jour les paramètres de l'URL
function updateUrlParams(url, params) {
    var urlObj = new URL((url), window.location.origin); // Utilise l'origine pour éviter les erreurs
    Object.keys(params).forEach(function (key) {
        urlObj.searchParams.set(key, params[key]);
    });
    return urlObj.toString().replace(window.location.origin, ''); // Supprime l'origine pour ne garder que le chemin relatif
}

// Appeler la fonction au chargement de la page
$(document).ready(function () {
    applyPriceFilter();
});


/**
 * This function reply to TK specific scroll behavior
 */
var scrollRestoration = {
    init: function () {
        if(performance.getEntriesByType("navigation")[0].type == "back_forward"){

            if (sessionStorage['scrollPosition_PLP']) {
                history.scrollRestoration = "manual";
            }
            $(document).ready(function () {
                scrollRestoration.restore();
            })
        }
       
    },
    restore: function () {
        var cat = window.location.href.split('?')[0].split('/').pop();
        if (sessionStorage['scrollPosition_PLP']) {
            var lastLocation = JSON.parse(sessionStorage['scrollPosition_PLP'])
            if(lastLocation.cat == cat){
                $(document).scrollTop(lastLocation.position);
            }else{
                sessionStorage.removeItem('scrollPosition_PLP');
            }
            
        }
    }
}

scrollRestoration.init();


